export default {"src":"/_next/static/media/square-area-outline.b4d4170a.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};